module.exports = __webpack_public_path__ + "img/img_search_empty@3x.98280cd5.png";